<div
    class="relative grow overflow-y-auto"
    [ngClass]="{'blur-[2px] pointer-events-none [&_*]:select-none': loading$ | async}"
>

    @if (loading$ | async) {
        <div class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50">
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>
    }

    <valben-table
        [columns]="cols"
        [values]="tableValues"
        [refresh]="refresh"
        [showEdit]="false"
        [showHistory]="false">
    </valben-table>
</div>
